import { Flex, Text } from "@aws-amplify/ui-react";

export default function ContactEmailPhoneCardContent({
  primaryPhone,
  secondaryPhone,
  workPhone,
}) {
  return (
    <Flex direction="column">
      <Flex gap="45px" direction="row">
        <Flex gap={3} direction="column">
          <Text
            fontFamily="Inter"
            children={`Primary Phone: ${primaryPhone || ""}`}
          ></Text>
          <Text
            fontFamily="Inter"
            children={`Secondary Phone: ${secondaryPhone || ""}`}
          ></Text>
          <Text
            fontFamily="Inter"
            children={`Work Phone: ${workPhone || ""}`}
          ></Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
